module.exports = __webpack_public_path__ + "assets/img/thumb-Brighten-Home-Loans-Website.f9ab74fa.webp";